import lodashCloneDeep from "lodash.clonedeep";

const cloneDeep = (obj: any) => lodashCloneDeep(obj);

export default cloneDeep;
